import React from "react";
import { Effect, LazyLoadImage as LazyImg } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

type LazyLoadImageProps = {
  alt: string;
  src: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  width?: number | string;
  height?: number | string;
  key?: string;
  effect?: Effect;
  wrapperClassName?: string;
  delay?: number; // delay in milliseconds before showing the image (default: 300)
  visibleByDefault?: boolean; // skip intersection observer and load immediately
  onLoad?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
};

export const LazyLoadImage = ({
  alt = "",
  src,
  className,
  style,
  onClick,
  width,
  height,
  key,
  effect = "blur",
  wrapperClassName,
  delay = 300,
  visibleByDefault = false,
  onLoad,
  onError,
}: LazyLoadImageProps) => (
  <LazyImg
    src={src}
    alt={alt}
    className={className}
    style={style}
    onClick={onClick}
    width={width}
    height={height}
    key={key}
    effect={effect}
    wrapperClassName={wrapperClassName}
    delayTime={delay}
    visibleByDefault={visibleByDefault}
    onLoad={onLoad}
    onError={onError}
  />
);
